import { UI_COLOR_SKELETON_BAR, UI_COLOR_TEXT_DIALOG_TITLE, UI_COLOR_TEXT_TABLE_MUTED } from '../../../constants/uiColors'

export const rbacTableSkeletonBarSx = {
  bgcolor: UI_COLOR_SKELETON_BAR,
  transform: 'none'
}

export const rbacSessionsCountSx = {
  fontSize: '13.5px',
  color: UI_COLOR_TEXT_DIALOG_TITLE
}

export const rbacSessionsMetaSx = {
  mt: 0.25,
  color: UI_COLOR_TEXT_TABLE_MUTED,
  fontSize: 12,
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}
